<template>
  <div class="memlist-date-picker ml-date-picker" :class="layoutClass">
    <template v-if="layout === 'horizontal'">
      <div class="horizontal1" v-if="title">
        <label class="ml-text-label">{{ title === " " ? "\u00A0" : title }}</label>
      </div>
      <div class="horizontal2">
        <date-picker
          :class="state_class"
          :disabled="disabled"
          :placeholder="placeholder"
          :format="format"
          v-model="local_value"
          valueType="format"
          @change="on_change"
        />
      </div>
    </template>

    <template v-else>
      <label class="ml-text-label" v-if="title">{{ title === " " ? "\u00A0" : title }}</label>
      <date-picker
        :class="state_class"
        :disabled="disabled"
        :placeholder="placeholder"
        :format="format"
        v-model="local_value"
        valueType="format"
        @change="on_change"
      />
    </template>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import dayjs from 'dayjs';

export default {

  name: 'memlist-date-picker',

  props: {
    value: String,
    state: {
      type: Boolean,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    format: String,
    title: String,
    layout: {
      type: String,
      default: 'vertical',
      validator: v => ['horizontal', 'vertical'].includes(v)
    }
  },

  mixins: [ toasts ],

  emits: ['input', 'change'],

  components: {
    DatePicker
  },

  watch: {
    value: {
      deep: true,
      handler(val) {

        this.local_value = val;

      }
    },
    local_value: {
      deep: true,
      handler(val) {
        this.$emit('input', this.local_value);
      }
    }
  },

  computed: {
    
    layoutClass() {
      return this.layout === 'horizontal' ? 'horizontal' : '';
    },

    state_class() {
      if (this.state === true) return 'success';
      if (this.state === false) return 'failure';

      return '';
    }
  },

  mounted() {

    if (this.value) {
      this.local_value = this.value;
    }

  },

  methods: {
    valid_date(date) {
      return dayjs(date).isValid()
    },
    on_change() {
      this.$emit('change');
    },
  },


  data() {
    return {

      local_value: null

    };
  }
};
</script>

<style lang="css" scoped>
.ml-text-label {
  font-size: 13px;
}

.memlist-date-picker {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.memlist-date-picker.horizontal {
  flex-direction: row;
  align-items: center;
}

.horizontal1 {
  width: 50%;
  text-align: right;
  padding-right: 16px;
}

.horizontal2 {
  width: 50%;
}

.memlist-date-picker label {
  font-weight: 500;
  font-size: 13px;
  margin-bottom: 2px;
}


:deep(.mx-datepicker) {
  border: none !important;
}

:deep(.mx-datepicker .mx-input) {
  border: 1px solid #E4E6EF; /* default neutral */
}

:deep(.failure .mx-input) {
  border: 1px solid #fd397a !important;
}

:deep(.success .mx-input) {
  border: 1px solid #1BC5BD !important;
}

:deep(.mx-input) {
  height: calc(1.5em + 1.3rem + 1px);
  cursor: pointer;
}

</style>
